import React from 'react';
import Setup from './src/boot/setup';
import { sentryInit } from './src/components/sentryReport';

if (!__DEV__)
			sentryInit({
				dsn: 'https://fcb9904d1fbd44ce82f61561f13aa1db@o256575.ingest.sentry.io/1448505'
			});
			
export default class App extends React.Component {
	constructor() {
		super();
		//Sentry.enableInExpoDevelopment = false;
		
	}
	render() {
		return <Setup />;
	}
}
